<template>
  <b-row id="contact-form" class="mx-auto" :class="{ 'section-invert': black && !isolated, 'section': !black && !isolated, 'py-10': !black, 'mobile-maxheight':  $uiHelpers.isMobile }">
    <b-col lg="6" md="12" :class="{ 'bg-black': black, 'content my-lg-auto mt-sm-auto pr-lg-5': true, 'mobile': $uiHelpers.isMobile }">
      <h3> {{ title }}</h3>
    </b-col>
    <b-col lg="6" md="12" class="content pl-lg-5" :class="{'mobile-form': $uiHelpers.isMobile, 'os-bg-white': black, 'my-auto': !black }">
      <div :class="{ 'py-sm-10 pl-sm-5': black }">
        <div>
					<b-row>
						<b-col>
							<base-select v-model="form.entityType" :options="formOptions.entityTypes" class="mb-4" :placeholder="$t('companies-contact-form.select-entity-type')"/>
						</b-col>
					</b-row>
          <b-row>
            <b-col lg="6" md="12" class="pr-lg-2">
              <base-input v-model="form.firstName" :placeholder="$t('companies-contact-form.form.name')"></base-input>
            </b-col>
            <b-col lg="6" md="12" class="pl-lg-2">
              <base-input v-model="form.lastName" :placeholder="$t('companies-contact-form.form.surnames')"></base-input>
            </b-col>
          </b-row>
          <base-input v-model="form.phone" :placeholder="$t('companies-contact-form.form.phone-number')"></base-input>
          <!-- <base-select v-model="form.state" valueProp="value" :options="formOptions.provinces" :placeholder="$t('form.province')"></base-select> -->
          <base-input v-model="form.email" :placeholder="$t('companies-contact-form.form.email')"></base-input>
          <base-textarea v-model="form.reason" :placeholder="$t('companies-contact-form.form.explain-case')"></base-textarea>
          <p>
            {{ $t('companies-contact-form.form.disclaimers.personal', { platform: platform })}}
          </p>
          <base-checkbox v-model="formLegalConsentOptions.privacyPolicy">
            <span v-html="$t('companies-contact-form.form.disclaimers.privacy')"></span>
          </base-checkbox>
          <base-button outline black @click="sendContactForm">{{ $t('send') }}</base-button>
        </div>
       <!--  <div v-else style="text-transform: uppercase">
          <span v-html="$t('form.success')"></span>
        </div> -->
      </div>
    </b-col>
  </b-row>
</template>

<script>
import es from '@/lang/es/forms/companies-contact-form.json'
import en from '@/lang/en/forms/companies-contact-form.json'
import pt from '@/lang/pt/forms/companies-contact-form.json'
import MarketingRepository from '@/repositories/MarketingRepository'
import GeographyRepository from '@/repositories/GeographyRepository'
import { map } from 'lodash'
import BaseAlert from '@/components/base/ui/BaseAlert'
import BaseSelect from '@/components/base/forms/BaseSelect'

export default {
  name: 'ContactForm',
  components: {
    BaseAlert,
		BaseSelect
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es,
      pt
    }
  },
  methods: {
    sendContactForm () {
			if (this.form.entityType == null) {
				this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-entity-type'))
				return
			}
      if (this.form.entityType == null && !this.forIndividuals && !this.forIndividualsOnly) {
        this.form.entityType = 'company'
      } else if (this.form.entityType == null && this.forIndividualsOnly) {
        this.form.entityType = 'individual'
      } else if (this.form.entityType == null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-entity-type'))
        return
      }
      if (!this.formLegalConsentOptions.privacyPolicy) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-consent'))
        return
      }
      if (!this.formLegalConsentOptions.privacyPolicy) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-consent'))
      }

      this.form.trafficSource = this.$route.query.utm_source || 'organic'

      this.form.productName = this.productName
      MarketingRepository.sendCompaniesContactForm(this.form).then(response => {
        /* this.$store.dispatch('showAlert', { text: this.$t('form.success'), variant: 'success' }) */
				if (!response || !response.status || response.status !== 200) {
					this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
					return
				}
        this.$router.push(this.callbackPath)
      })
    }
  },
  props: {
    black: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default () {
        return this.$t('companies-contact-form.contact-us')
      }
    },
    platform: {
      type: String,
      required: false,
      default: 'Opensalud'
    },
    productName: {
      type: String,
      required: false,
      default: 'opensalud'
    },
    subtitle: {
      type: String,
      required: false
    },
    serviceType: {
      type: String,
      required: false,
      default () {
        return this.$t('companies-contact-form.service-type.digital-health')
      }
    },
    forIndividuals: {
      type: Boolean,
      required: false,
      default: false
    },
    forIndividualsOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    forCompaniesOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    showDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    hideEmployeesNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    showReason: {
      type: Boolean,
      required: false,
      default: false
    },
    showCollegiateNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    hideWebsite: {
      type: Boolean,
      required: false,
      default: false
    },
    callbackPath: {
      type: String,
      required: false,
      default: '/contact/success'
    },
    isolated: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      form: {
        firstName: null,
        lastName: null,
        description: null,
        phone: null,
/*         state: null, */
        email: null,
        entityType: null,
        reason: null
      },
      formOptions: {
        entityTypes: [
					{ value: 'Profesional', label: this.$t('companies-contact-form.form.entity-type.health-professional') },
					{ value: 'Empresa', label: this.$t('companies-contact-form.form.entity-type.company') },
          { value: 'Particular', label: this.$t('companies-contact-form.form.entity-type.individual') },
					{ value: 'Usuario empresa', label: this.$t('companies-contact-form.form.entity-type.company-user') },
					{ value: 'Otros', label: this.$t('companies-contact-form.form.entity-type.others') }
        ],
        employeesNum: [
            {
              value: '1',
              label: '1-10'
            },
            {
              value: '2',
              label: '11-50'
            },
            {
              value: '3',
              label: '51-200'
            },
            {
              value: '4',
              label: '201-500'
            },
            {
              value: '5',
              label: '501-1000'
            },
            {
              value: '6',
              label: '1001-5000'
            },
            {
              value: '7',
              label: '5001-10000'
            },
            {
              value: '8',
              label: '10000+'
            }
          ],
        provinces: []
      },
      formLegalConsentOptions: {
        privacyPolicy: false,
        subscriptionTypeId: '8323529'
      }
    }
  },
  mounted () {
    GeographyRepository.getStatesByCountry(28).then(response => {
      this.formOptions.provinces = map(response.data.sort((a, b) => this.$i18nHelpers.normalize(a.name).localeCompare(this.$i18nHelpers.normalize(b.name))), item => {
        const stateName = this.$i18nHelpers.normalize(item.name)
        return {
          value: stateName,
          label: stateName
        }
      })
    })
    if (this.forCompaniesOnly && !this.form.entityType) {
      this.form.entityType = 'company'
    } else if (this.forIndividualsOnly && !this.form.entityType) {
      this.form.entityType = 'individual'
    }
  },
  computed: {
    isCompany () {
      return ((!this.forIndividuals || this.form.entityType === 'company') && !this.forIndividualsOnly) || this.forCompaniesOnly
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ h3 {
  @include title-sm;
}
.mobile{
  padding-bottom: 0rem !important;
}
.mobile-subtitle{
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
}
.mobile-form{
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
}
.mobile-maxheight{
  min-height: 77vh !important;
}
.section {
  @include section;
  @include container-padding;
}

.bg-black {
  background-color: $black;
  color: $white;
}

.no-full-height {
  min-height: initial !important;
}

.os-bg-white {
  background-color: #E4E4E4 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/forms/ContactForm.vue